import call from './call';
import {GET_USERS} from "../types";

export default (form) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
            dispatch({type: GET_USERS, payload: {entries: result[1].results, total:result[1].total, kind:'users'}});
    };
    dispatch(call("UserService/getAllPKIUsers",form,onResult));
};